import { DOCUMENT_CONSTANTS } from '../constants/document';

import type { DocumentData } from '../types/document';

/**
 * Document utility functions for transformation and parsing
 */

/**
 * Transform raw document response to DocumentData format
 */
export const transformDocumentData = (selectedDocument: any, selectedDocId: string | null): DocumentData | null => {
    if (!selectedDocument) {
        return null;
    }

    return {
        id: selectedDocument.id || selectedDocId || '',
        title:
            selectedDocument.title ||
            selectedDocument.name ||
            `${DOCUMENT_CONSTANTS.DEFAULT_DOCUMENT_TITLE} ${selectedDocId}`,
        content: selectedDocument.content ?? '',
        name: selectedDocument.name,
        createdAt: selectedDocument.createdAt,
        updatedAt: selectedDocument.updatedAt,
        version: selectedDocument.version,
        externalType: selectedDocument.externalType,
        externalId: selectedDocument.externalId,
        meta$: selectedDocument.meta$,
    };
};

/**
 * Format timestamp to localized date string
 */
export const formatDocumentDate = (timestamp?: number): string | null => {
    if (!timestamp) {
        return null;
    }

    return new Date(timestamp).toLocaleDateString(
        DOCUMENT_CONSTANTS.DATE_FORMAT_LOCALE,
        DOCUMENT_CONSTANTS.DATE_FORMAT_OPTIONS
    );
};

/**
 * Extract document ID from compound ID (removes colon suffix)
 */
export const extractDocumentId = (compoundId: string): string => {
    return compoundId.split(':')[0];
};
